import { COLORS } from './designSystem';

const VARIANT_MAP = {
  h1: { fontSize: 28, fontWeight: '700' },
  h2: { fontSize: 22, fontWeight: '600' },
  h3: { fontSize: 18, fontWeight: '600' },
  body: { fontSize: 15, fontWeight: '400' },
  caption: { fontSize: 12, fontWeight: '400', opacity: 0.8 }
};

export const Text = ({
  h1,
  h2,
  h3,
  body,
  caption,
  style,
  bold,
  italic,
  size,
  color,
  center,
  upCase,
  value,
  wrap,
  primary,
  greyLight,
  grey,
  greyDark,
  success,
  warning,
  error,
  text,
  textLight,
  white,
  black,
  variant, // fallback se non passi h1-h3-body-caption
}) => {
  // Controlla quali props di tipo variant sono passate
  const resolvedVariant =
    (h1 && VARIANT_MAP.h1) ||
    (h2 && VARIANT_MAP.h2) ||
    (h3 && VARIANT_MAP.h3) ||
    (body && VARIANT_MAP.body) ||
    (caption && VARIANT_MAP.caption) ||
    VARIANT_MAP[variant] || VARIANT_MAP.body;

  const resolvedColor =
    color ||
    (primary && COLORS.primary) ||
    (greyLight && COLORS.greyLight) ||
    (grey && COLORS.grey) ||
    (greyDark && COLORS.greyDark) ||
    (success && COLORS.success) ||
    (warning && COLORS.warning) ||
    (error && COLORS.error) ||
    (text && COLORS.text) ||
    (textLight && COLORS.textLight) ||
    (white && COLORS.white) ||
    (black && COLORS.black) ||
    COLORS.text;

  return (
    <div
      style={{
        fontWeight: bold ? 'bold' : resolvedVariant.fontWeight,
        fontStyle: italic ? 'italic' : 'normal',
        fontSize: size || resolvedVariant.fontSize,
        fontFamily: 'Poppins, sans-serif',
        color: resolvedColor,
        textAlign: center ? 'center' : 'start',
        textWrap: wrap ? 'wrap' : 'stable',
        ...style
      }}
    >
      {upCase ? String(value).toUpperCase() : value}
    </div>
  );
};
